const DESCRIPTION_LENGTH = 160 - 3

export default {
    computed: {
        _pageTitle() {
            return this.pageTitle || this.$route.meta.pageTitle
        },

        _pageDescription() {
            const pageDescription =
                this.pageDescription ||
                this.$route.meta.pageDescription ||
                process.env.VUE_APP_DESCRIPTION
            if (pageDescription.length > DESCRIPTION_LENGTH)
                return `${pageDescription.substring(0, DESCRIPTION_LENGTH)}...`

            return pageDescription
        },

        _pageKeywords() {
            return (
                this.pageKeywords || this.$route.meta.pageKeywords || process.env.VUE_APP_KEYWORDS
            )
        },

        _defaultLogo() {
            return window.location.origin + '/images/logo.png'
        },

        _pageImage() {
            return this.pageImage || this.$route.meta.pageImage || this._defaultLogo
        },
        _pageLink() {
            return this.pageLink ?? undefined
        },
    },

    metaInfo() {
        return {
            htmlAttrs: {
                lang: 'en',
            },
            meta: [
                { name: 'description', content: this._pageDescription },
                { name: 'keywords', content: this._pageKeywords },
                { name: 'og:type', content: 'website' },
                {
                    name: 'og:title',
                    content: this._pageTitle || process.env.VUE_APP_NAME,
                },
                { name: 'og:description', content: this._pageDescription },
                { name: 'og:image', content: this._pageImage },
            ],
            link: [...(this._pageLink ? [{ rel: 'canonical', href: this._pageLink }] : [])],
            title: this._pageTitle,
            titleTemplate: this.pageTitle
                ? '%s | ' + process.env.VUE_APP_NAME
                : process.env.VUE_APP_NAME,
        }
    },
}
